{
  "agreements": {
    "column": {
      "claim-option": "Opción de reclamación",
      "currency": "Moneda",
      "description": "Descripción",
      "more": "más",
      "number": "N.º",
      "type": "Tipo",
      "valid-from": "Válido desde",
      "valid-to": "Válido hasta"
    },
    "header": {
      "intro": "Consulte sus acuerdos actuales. Haga clic en el botón «enviar reclamación» para iniciar una reclamación.",
      "title": "Resumen de acuerdos"
    },
    "product": {
      "billback-rate": "Tarifa Billback / kg.",
      "code": "Código LW",
      "name": "Productos"
    },
    "table": {
      "detail": {
        "contact": "Contacto:",
        "lwm-contact": "Contacto de LW:",
        "download-pdf": "Descargar acuerdo en PDF"
      },
      "empty": "No hay acuerdos disponibles",
      "submit-claim": "Enviar reclamación"
    },
    "type": {
      "billback": "Acuerdo Billback QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "La contraseña debe cumplir los siguientes requisitos: Longitud mínima de 6 caracteres; caracteres del alfabeto inglés en mayúsculas (A-Z); caracteres del alfabeto inglés en minúsculas (a-z); Base numérica de 10 dígitos (0-9)",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "2 errores de validación detectados: Valor proporcionado para \"contraseña\" no satisface la restricción: Miembro debe coincidir con el patrón de expresión regular: ^[\\S]+.*[\\S]+$; Valor proporcionado para \"contraseña\" no satisface la restricción: El mínimo requerido de caracteres para miembro es mayor o igual a 6",
    "Account recovery requires verified contact information": "La recuperación de la cuenta requiere datos de contacto verificados",
    "An account with the given email already exists.": "Ya existe una cuenta asociada al correo electrónico proporcionado.",
    "Apply code from MFA app": "Introduce el código de tu servicio de autenticación multifactor.",
    "Apply code from SMS": "Introduce el código enviado a tu dispositivo móvil.",
    "Back to Sign In": "Volver a inicio de sesión",
    "Cancel": "Cancelar",
    "Change Password": "Cambiar contraseña",
    "Code": "Código",
    "Confirm": "Confirmar",
    "Confirm password": "Confirmar contraseña",
    "Confirm Sign In": "Confirmar inicio de sesión",
    "Confirm Sign Up": "Memos enviado un código de confirmación al correo electrónico.",
    "Confirm a Code": "Confirmar un código",
    "Confirmation Code": "Código de confirmación",
    "Create Account": "Crear cuenta",
    "Create a new account": "Crear cuenta nueva",
    "Create account": "Crear cuenta",
    "Custom auth lambda trigger is not configured for the user pool.": "Contraseña no puede estar vacío",
    "Email": "Correo electrónico",
    "Email address": "Dirección de correo electrónico",
    "Enter your Email address": "Introducir dirección de correo electrónico",
    "Enter your password": "Introducir contraseña",
    "Enter your username": "Introducir nombre de usuario",
    "Forgot Password": "Contraseña olvidada",
    "Forgot your password? ": "¿Has olvidado tu contraseña?",
    "Have an account? ": "¿Tienes una cuenta?",
    "Incorrect username or password": "Nombre de usuario o contraseña incorrectos",
    "Invalid code received for user": "Código inválido recibido para el usuario",
    "Invalid password format": "Formato de contraseña inválido",
    "Invalid phone number format": "Contraseña con formato no válido",
    "Loading": "Cargando",
    "Lost your code? ": "¿No encuentras tu código?",
    "New Password": "Contraseña nueva",
    "No account? ": "¿No tienes cuenta?",
    "Password": "Contraseña",
    "Password attempts exceeded": "Máximo de intentos de contraseña superado",
    "Phone Number": "Número de teléfono",
    "Please confirm your password": "Por favor confirme su contraseña",
    "Remember this device": "Recordar este dispositivo",
    "Resend Code": "Reenviar código",
    "Reset password": "Restablecer contraseña",
    "Reset your password": "Restablecer tu contraseña",
    "Send Code": "Enviar código",
    "Set MFA": "Establecer AMF",
    "Sign In": "Iniciar sesión",
    "Sign Out": "Cerrar sesión",
    "Sign Up": "Inscribirse",
    "Sign in": "Iniciar sesión",
    "Sign in to your account": "Accede a tu cuenta",
    "Skip": "Saltar",
    "Submit": "Presentar",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "User does not exist.": "El usuario no existe.",
    "Username": "Nombre de usuario",
    "Username cannot be empty": "El nombre de usuario no puede estar vacío",
    "Username/client id combination not found.": "Combinación nombre de usuario/identificación de cliente no encontrada.",
    "Verification Code": "Código de verificación",
    "Verify": "Verificar",
    "Verify Contact": "Verificar contacto",
    "Verify Token": "Verificar"
  },
  "authentication": {
    "link-corporate": "Ir a",
    "verification_message": "Hemos enviado un código de confirmación a tu correo electrónico.",
    "warning": {
      "requires-mfa": "Solo disponible para los usuarios que tienen activada la autenticación multifactor. Puedes configurar la autenticación multifactor en "
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Importe Billback",
      "contract-no": "N.º de contrato",
      "description": "Descripción",
      "info": "Información",
      "posting-date": "Fecha",
      "status": "Estado",
      "type": "Tipo"
    },
    "empty": "No hay reclamaciones disponibles",
    "header": {
      "intro": "Consulte sus reclamaciones actuales.",
      "title": "Resumen de reclamaciones enviadas"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Cerrar mensaje",
        "message": "Estimado cliente, gracias por su información. Su reclamación se revisará y se resolverá en un plazo de 3 a 4 semanas. Si tiene alguna pregunta, póngase en contacto con su persona de contacto comercial de LW/M.",
        "title": "Su reclamación ha sido enviada"
      },
      "footer": {
        "back": "Volver",
        "next": "Siguiente",
        "submit": "Enviar reclamación",
        "total-billback-amount": "Importe Billback total",
        "total-claim-amount": "Importe total de la reclamación: ",
        "total-volume": "Volumen total: "
      },
      "items": {
        "bags": "Bolsas",
        "billback-amount": "Importe Billback",
        "billback-rate": "Tarifa Billback",
        "boxes": "Cajas",
        "volume": "Volumen"
      },
      "new-claim-button": "Enviar nueva reclamación",
      "repeat-button": {
        "large1": "¿Desea iniciar otra reclamación?",
        "large2": "Volver al resumen de reclamaciones",
        "small": "Resumen de reclamaciones"
      },
      "steps": {
        "claim-details": "Rellenar los detalles de la reclamación",
        "claim-summary": "Resumen de la reclamación",
        "details": {
          "agreement-details": "Detalles del acuerdo",
          "applicant": "Solicitante",
          "currency": "Moneda:",
          "header": "Detalles de la reclamación",
          "valid-range": "Válido de-a: {from} a {to}",
          "wholesale-party": "Mayorista"
        },
        "details-form": {
          "credit-reference": {
            "label": "Referencia de crédito",
            "placeholder": "Por favor, indique su referencia de crédito"
          },
          "header": "Rellenar los detalles de la reclamación",
          "intro": "Seleccione los productos para su reclamación de reembolso. Le rogamos que también nos indique el mayorista al que solicitó sus productos.",
          "period": {
            "clear": "Borrar",
            "label": "Periodo de reclamación de - a",
            "placeholder": "Por favor, seleccione su periodo de reclamación"
          },
          "wholesale-party": {
            "label": "Mayorista",
            "placeholder": "Por favor, indique su mayorista"
          }
        },
        "proof": {
          "attachment": {
            "label": "Por favor, aporte el comprobante de compra de todos los artículos añadidos arriba",
            "placeholder": "Arrastre y suelte los archivos aquí o haga clic para subirlos.  (máx. 25 MB) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG admitidos"
          },
          "header": "Aportar comprobante"
        },
        "summary": {
          "header": "Resumen de su reclamación ",
          "your-billback-claim": "Su reclamación Billback"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "Si tiene alguna pregunta, póngase en contacto con su persona de contacto comercial de LW EMEA.",
        "title": "Resumen de la reclamación"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Buscar..."
      },
      "total": "Total"
    },
    "status": {
      "failed": "Fallida",
      "submitted": "Enviada"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Atrás",
      "calculate": "Calcular",
      "download": "Descargar",
      "next": "Siguiente"
    },
    "download": {
      "download": "Descarga el cálculo de tu pedido ",
      "file-type": "Archivo CSV",
      "intro": {
        "done": "¡Ya está listo el cálculo de tu pedido de contenedores!",
        "download": "Puedes descargar tu cálculo de contenedores mediante descarga CSV."
      },
      "title": "Descarga cálculo pedido en formato CSV"
    },
    "header": {
      "intro": {
        "step-1": "Selecciona si quieres que utilicemos una hoja deslizante o palés para tu pedido de contenedores.",
        "step-2": "Añade los productos deseados.",
        "step-3": "El sistema calculará si se requieren algunos artículos adicionales para rellenar y aprovechar al máximo el espacio del contenedor."
      },
      "title": "Selecciona los productos para el contenedor"
    },
    "load-base": {
      "pallet": "Palés",
      "sheet": "Hojas"
    },
    "result": {
      "filled": {
        "description": "Haz clic en Siguiente para continuar.",
        "message": "La selección actual de productos cabe en un contenedor. "
      },
      "initial": {
        "description": "",
        "message": "Te asistiremos en el llenado del contenedor hasta el máximo espacio disponible. Por favor, introduce la cantidad de palés y haz clic en “Calcular”. Si procede, la calculadora dará información para optimizar el espacio del contenedor."
      },
      "overfilled": {
        "description": "Te hemos hecho una sugerencia basada en el artículo de mayor cantidad que puedes aceptar haciendo clic en el botón naranja. Podrás realizar los ajustes alternativos según veas conveniente cambiando la cantidad de cualquier artículo de la lista. Haz clic en “Siguiente” una vez que se haya ocupado todo el espacio del contenedor.",
        "message": "Para llenar el contenedor hasta su máxima capacidad, hay que retirar palés."
      },
      "overfilled-no-product": {
        "description": "La selección actual de productos no se ajusta al espacio disponible en el contenedor. Por favor, reduce tu selección de productos con {count} paletas.",
        "message": "Has añadido demasiados palés."
      },
      "totals": {
        "boxes": "Cartones:",
        "kg": "kg",
        "pallets": "Palés:",
        "title": "Total",
        "weight": "Peso bruto estimado:"
      },
      "underfilled": {
        "description": "La sugerencia que te hacemos se basa en el artículo de mayor cantidad. Puedes aceptar esta configuración haciendo clic en el botón naranja. Podrás realizar los ajustes alternativos según veas conveniente cambiando la cantidad de cualquier artículo de la lista. Haz clic en “Siguiente” una vez que se haya ocupado todo el espacio del contenedor.",
        "message": "Para llenar el contenedor hasta su máxima capacidad, hay que añadir palés."
      }
    },
    "steps": {
      "select-products": "Selecciona los productos para el contenedor",
      "summary": "Descarga cálculo pedido en formato CSV"
    },
    "suggestion": {
      "add": "Añadir {amount}",
      "reduce": "Retirar {amount}"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "Número de contrato:",
        "to": "para",
        "total-volume": "Volumen total del contrato:",
        "valid-from-to": "Válido del/al"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "Debido a cambios en el mercado, la información en sus contratos de volumen puede verse alterada. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Cambios en el mercado"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Intercambio de productos en contratos"
      },
      "button": "Ir a mis contratos de volumen",
      "card": {
        "link": "descargo de responsabilidad",
        "text": "Lea nuestro descargo de responsabilidad para obtener más información sobre posibles variaciones en esta descripción general"
      },
      "need-help": {
        "content": "Si tiene alguna pregunta de seguimiento o necesita información más detallada sobre sus contratos de volumen, comuníquese con su {link}.",
        "link": "persona de contacto o el equipo de experiencia de cliente",
        "title": "¿Necesita ayuda?"
      },
      "title": "Descargo de responsabilidad"
    },
    "download": {
      "button": "Descargar",
      "label": "Seleccione la información del contrato que desea descargar"
    },
    "header": {
      "intro": "Obtenga información sobre sus contratos. Si tiene alguna pregunta, no dude en contactarnos.",
      "title": "Mis contratos de volumen"
    },
    "products": {
      "header": {
        "billed-qty": "Cantidad facturada en kg",
        "code": "Código LW",
        "contract-qty": "Cantidad del contrato en kg",
        "kg-left": "kg que han quedado",
        "material": "Material",
        "open-orders": "Órdenes pendientes en kg",
        "percent-left": "Porcentaje que ha quedado",
        "product": "Nombre del producto"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Ir a mis facturas",
      "my-invoices": "Mis facturas",
      "open-invoices": "Facturas abiertas",
      "upcoming": "Próximamente",
      "your-open-invoices": "Tus facturas pendientes"
    },
    "orders": {
      "go-to-orders-overview": "Ir al resumen de pedidos y entregas",
      "last-order": "Último pedido",
      "my-orders-deliveries": "Mis pedidos y entregas",
      "no-last-order": "No hay último pedido disponible",
      "order-date": "Fecha del pedido",
      "order-status": "Estado del pedido",
      "your-orders-deliveries": "Tus pedidos y entregas"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Seguir",
      "enroll": "Inscribirse",
      "view": "Ver"
    },
    "course": {
      "finish": {
        "button": "He terminado este curso",
        "description": "Haz clic en el botón para confirmar que este curso se ha terminado.",
        "title": "¿Has terminado este curso?"
      },
      "header": {
        "back": "Vover a la página de resumen",
        "status": "Estado:"
      },
      "related": {
        "default-title": "Otros cursos"
      }
    },
    "minutes": "minutos",
    "overview": {
      "empty": "No se han encontrado cursos",
      "search-bar": {
        "category": {
          "all": "Todo",
          "placeholder": "Categoría: Todas"
        },
        "duration": {
          "all": "Todo",
          "more-than": "Más de",
          "placeholder": "Duración: Todo"
        },
        "result-title": "({count}) Resultados de la búsqueda de: | ({count}) Resultado de la búsqueda de: | ({count}) Resultados de la búsqueda de:",
        "search": {
          "placeholder": "Búsqueda..."
        },
        "status": {
          "all": "Todo",
          "placeholder": "Estado: Todos"
        }
      },
      "title": "Aprendizaje electrónico"
    },
    "status": {
      "completed": "Terminado",
      "in-progress": "En curso",
      "not-started": "No empezado"
    }
  },
  "eatThis": {
    "download": "descargar ahora",
    "open": "abrir"
  },
  "error": {
    "error_404": {
      "title": "Uy, página no encontrada"
    },
    "error_500": {
      "title": "Uy, error 500"
    },
    "general": {
      "subtitle": "parece que esta página no funciona",
      "title": "Uy, error desconocido"
    }
  },
  "footer": {
    "copyright": "© {year} Todos los derechos reservados Lamb Weston",
    "navigation": {
      "privacy": "Privacidad",
      "profile": "Perfil",
      "terms-and-conditions": "Términos y condiciones"
    }
  },
  "general": {
    "for": "para",
    "interface": {
      "back": "Volver",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "remove": "Eliminar",
      "save": "Guardar",
      "update": "Actualizar",
      "none": "Ninguno",
      "noResultsFound": "No se encontraron resultados",
      "all": "Todo",
      "create": "Crear",
      "next": "Próximo"
    },
    "locale": {
      "de": "Alemán",
      "en-GB": "Inglés",
      "es": "Español",
      "fr": "Francés",
      "it": "Italiano",
      "nl": "Neerlandés"
    },
    "messages": {
      "error": "Se ha producido un error inesperado."
    },
    "table": {
      "not-available": "no disponible"
    },
    "dialog": {
      "confirm_delete_message": "¿Está seguro de que desea eliminar este elemento?"
    }
  },
  "home": {
    "intro": "En el portal de clientes de Lamb Weston.",
    "title": "Bienvenido{fullname},",
    "subtitle": "Sirviendo con orgullo a {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Cantidad",
      "details": "Inf.",
      "expire-date": "Fecha de vencimiento",
      "invoice-nr": "N.º de factura",
      "posting-date": "Fecha de publicación",
      "sales-order": "Pedido de venta",
      "sales-order-show": "mostrar",
      "status": "Estado"
    },
    "detail": {
      "label": {
        "amount": "Cantidad",
        "currency": "Divisa",
        "expire-date": "Fecha de vencimiento",
        "invoice-number": "Número de factura",
        "order-reference": "Referencia del pedido",
        "payment-terms-code": "Código condiciones de pago",
        "payment-terms-description": "Descripción condiciones de pago",
        "posting-date": "Fecha de publicación",
        "relevant-bill-to": "Destinatario factura",
        "relevant-payer": "Pagador pertinente",
        "sales-order-ship-to": "Dirección de entrega pedido de venta",
        "type-commercial": "Tipo comercial"
      },
      "pdf-download": "Descarga PDF de factura",
      "sales-order": {
        "close": "Cerrar mensaje",
        "order-overview": "Ir a Mis pedidos",
        "title": "Factura {invoice} - Pedido de venta"
      },
      "show-sales-order": "Mostrar pedido de venta"
    },
    "empty": "No hay facturas disponibles",
    "header": {
      "intro": "En esta página podrás encontrar y descargar tus facturas. Haz clic en una fila para más información.",
      "title": "Mis facturas"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "Todas las facturas",
        "filter": "Filtrar facturas",
        "search": "Buscar..."
      },
      "total": "Total",
      "total-filtered": "total filtrado"
    },
    "status": {
      "before due": "plazo de pago vencido",
      "cleared": "pagado",
      "days-till-due-date": "{count} días|{count} día|{count} días",
      "due date": "fecha límite",
      "overdue": "atrasado",
      "reversed": "invertido"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "rezagado",
      "runner": "corredor",
      "sleeper": "durmiente",
      "winner": "ganador"
    },
    "imageAlt": {
      "icon": "Icono categoría chef",
      "laggard": "Categoría chef rezagado",
      "runner": "Categoría chef corredor",
      "sleeper": "Categoría chef durmiente",
      "winner": "Categoría chef ganador"
    },
    "label": {
      "addDishEquation": "Tu plato ha sido añadido a la ecuación",
      "categoryResult": {
        "intro": "A continuación encontrarás los resultados de tus platos en las cuatro categorías de",
        "link": "Ingeniería de menús",
        "outro": "Haz clic en la categoría para ver qué platos entran en ella y obtener consejos para optimizar tus platos."
      },
      "companySeatCount": "Capacidad/número de plazas",
      "companyStaffSize": "Número de empleados",
      "cost": "Coste de los alimentos (€)",
      "course": {
        "breakfast": "Desayuno",
        "dinner": "Cena",
        "inbetween": "Tentempié",
        "lunch": "Almuerzo",
        "snack_time": "Piscolabis"
      },
      "courseDish": "Plato",
      "dishNotDeleted": "No se ha podido eliminar el plato",
      "editDish": "Tu plato ha sido editado",
      "goodCalculation": "Necesitamos al menos 5 platos para hacer un buen cálculo.",
      "helpTime": "Tiempo de ayuda en la cocina (min.)",
      "info": {
        "cost": "El precio de coste total de todos los ingredientes del plato.",
        "helpTime": "Tiempo empleado por el personal de cocina en la preparación de este plato.",
        "popularity": "¿Cuántas unidades de este plato se venden a la semana?",
        "price": "El precio de venta del plato en el menú antes de impuestos.",
        "time": "Tiempo empleado por el chef en la preparación de este plato."
      },
      "insufficientDishes": "Necesitamos al menos {count} platos más para hacer un buen cálculo.",
      "laggard": {
        "demand": "Baja demanda",
        "profit": "Pocos beneficios"
      },
      "laggards": "Rezagados",
      "nameOfDish": "Nombre del plato",
      "optionRestaurant": "Restaurante",
      "popularity": "Popularidad (veces a la semana)",
      "price": "Precio de venta sin  IVA (€)",
      "runner": {
        "demand": "Alta demanda",
        "profit": "Pocos beneficios"
      },
      "runners": "Corredores",
      "selectCourse": "Plato",
      "selectCourseLabel": "Elige un plato",
      "sleeper": {
        "demand": "Baja demanda",
        "profit": "Altos beneficios"
      },
      "sleepers": "Durmientes",
      "thinkOfYourDish": "Piensa en uno de tus platos. Y rellena el formulario.",
      "time": "Tiempo del chef para la elaboración (min)",
      "typeOfRestaurant": "¿Qué tipo de restaurante tienes?",
      "winner": {
        "demand": "Alta demanda",
        "profit": "Altos beneficios"
      },
      "winners": "Ganadores"
    },
    "overview": {
      "addAnotherDish": "Guardar y añadir otro",
      "addDish": "Añadir un plato",
      "addDishEquation": "Añadir un plato a la ecuación",
      "calculateNow": "Calcular ahora",
      "cancel": "Cancelar",
      "categoryCompare": "Comparado con otros platos del mercado, tu plato parece ser un",
      "categoryResult": {
        "intro": "Estos son los",
        "outro": "platos de tu menú "
      },
      "deleteProfile": "Estás a punto de eliminar tu perfil",
      "dishes": "Platos",
      "menuEngineering": "Ingeniería de menús",
      "results": "Resultados",
      "save": "Guardar",
      "showResults": "Mostrar los resultados",
      "startMenuEngineering": "Empieza a diseñar tu menú",
      "testValueDishes": "Comprueba el valor de tus platos",
      "typeOfRestaurant": "Tipo de restaurante",
      "yourDish": "Tu plato"
    },
    "placeholder": {
      "typeOfRestaurant": "Por ejemplo, asador, pizzería, etc."
    },
    "results": {
      "back-to-results": "Volver a mis resultados",
      "title": "Ingeniería de menú, mis resultados"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Piensa en uno de tus platos. Y rellena el formulario.",
        "title": "2. Tu plato"
      },
      "hero": {
        "subtitle": "La ingeniería de menús ayuda a evaluar los platos de tu menú y a obtener una visión general de los mejores y peores resultados.",
        "title": "Comprueba el valor real de tus platos"
      },
      "intro": {
        "text": "La ingeniería de menús hace una comparación de los platos entre sí, por lo que siempre habrá ganadores, durmientes, corredores y rezagados. Para obtener un buen resultado compara siempre platos del menú que sean similares, por ejemplo del segmento \"platos principales\".",
        "title": "Ingeniería de menús",
        "try": "¡Haz la prueba para un plato!"
      },
      "restaurant-type": {
        "label": "¿Puedes indicarnos el tipo de restaurante?",
        "subtitle": "¿Qué tipo de restaurante tienes?",
        "title": "1. Tipo de restaurante"
      },
      "result": {
        "sign-up": "Únete a nosotros y compara tus platos"
      }
    }
  },
  "navigation": {
    "approved-products": "{company} Cartera",
    "back-to-overview": "Volver al resumen",
    "best-practices": "Mejores prácticas/Libro de estrategias",
    "container-calculation": "Cálculo contenedor",
    "dashboard": "Panel de control",
    "e-learning": "Aprendizaje electrónico",
    "eat-this": "Eat This!",
    "lwm-company-information": "Empresa Lamb Weston",
    "lwm-contact": "Contactos de Lamb Weston",
    "market-activations": "Movilización del mercado",
    "menu-engineering": {
      "add-dish": "Añadir plato",
      "main": "Ingeniería de menús",
      "my-results": "Mis resultados",
      "try-out": "Comprueba el valor real de tus platos"
    },
    "my-agreements": "Mis acuerdos",
    "my-claims": "Mis reclamaciones",
    "my-invoices": "Mis facturas",
    "my-orders": "Mis pedidos y entregas",
    "my-volume-contracts": "Mis contratos de volumen",
    "new-products": "Innovaciones y tendencias",
    "partnership": "Colaboración con {company}",
    "permission-mgt": "Gestión de permisos",
    "product-information": "Información del producto",
    "products-for": "Portfolio de {company}",
    "settings": {
      "main": "Configuración",
      "my-profile": "Mi perfil"
    },
    "sign-out": "Cerrar sesión",
    "sustainability": "Agenda de sostenibilidad",
    "training": "Operaciones y formación",
    "trend-information": "Información sobre tendencias",
    "user-management": "Gestión de usuarios",
    "dock-scheduler": "Programador de muelles",
    "dock-scheduler-booking": "Resumen de reservas",
    "dock-scheduling-rules": "Reglas de programación de muelles"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "El código de validación debe tener 6 caracteres.",
        "unknown": "Se ha producido un error, por favor, inténtalo de nuevo."
      },
      "finish": "Finalizar",
      "qr-description": "Escanea el código QR con la aplicación de autenticación para obtener el código de autenticación multifactorial (MFA).",
      "qr-title": "Código de autenticación multifactorial (MFA)",
      "step-title": "Establecer el token de autenticación",
      "steps": "Descarga la aplicación Google authenticator en la tienda de apple o android|Pulsa el icono \"+\"|Selecciona \"Escanear código QR\"|Introduce el código de la aplicación en el campo \"Código de verificación\"",
      "title": "Aplicación de autenticación"
    },
    "change-mfa": "Cambiar",
    "finished": {
      "features-enabled": "Ya están disponibles todas las funciones del portal.",
      "finish": "Ir al panel de control",
      "intro": {
        "authenticator": "Gracias por configurar la autenticación multifactorial.\nA partir de ahora podrás iniciar sesión utilizando la autenticación multifactorial con tu aplicación de autenticación.",
        "sms": "Gracias por configurar la autenticación multifactorial.\nA partir de ahora podrás iniciar la sesión mediante la autenticación multifactorial con un mensaje de texto en tu móvil."
      },
      "title": "¡Autentificación verificada!"
    },
    "mfa-preference": "Autenticación multifactorial Preferencia",
    "none": {
      "description": "Si no estableces un método de autenticación multifactorial, solo podrás utilizar las funcionalidades del Portal dicho método. Si continúas sin configurar la MFA, esta ventana emergente volverá a aparecer en tu próxima visita.",
      "finish": "Continuar sin MFA",
      "title": "No activar MFA"
    },
    "sms": {
      "change-phone": "Cambiar número de teléfono",
      "code-sent": "Hemos enviado un código a tu móvil.",
      "finish": "Finalizar",
      "request-code": "Solicitar código",
      "steps": "Introduce tu número de teléfono y pulsa Solicitar código|En unos segundos deberías recibir un mensaje de texto con un código de verificación|Rellena el código de verificación y pulsa Finalizar para activarlo.",
      "title": "Mensajes de texto SMS"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(utiliza un código QR y una aplicación de autenticación multifactorial (MFA) para guardar un token en tu dispositivo móvil)",
          "type": "Aplicación de autenticación"
        },
        "none": {
          "label": "",
          "type": "No activar MFA"
        },
        "sms": {
          "label": "(recibe un código en tu dispositivo móvil).",
          "type": "Mensajes de texto SMS"
        }
      },
      "explanation-description": "La autenticación multifactorial (MFA) añade una capa de protección adicional para proteger tu nombre de usuario y contraseña. Por favor, proporciona un número de móvil válido para activar la autenticación por SMS.",
      "explanation-title": "Autenticación multifactorial Preferencia",
      "recommend-description": "Por motivos de seguridad, también recomendamos utilizar la autenticación multifactorial.",
      "required-description": "Bienvenido a al Portal del cliente. Para acceder a todas las funciones del portal del cliente se necesita la autenticación multifactorial. ",
      "title": "¡Bienvenido/a!"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Pedir estos productos de nuevo",
        "reorder": "¿Quieres repetir este pedido? Haz clic en el botón de repetir pedido.",
        "summary-info": "* La composición del pedido puede variar en función de la disponibilidad de las existencias; la confirmación de los artículos y las cantidades se enviará posteriormente. Lamb Weston y sus socios logísticos harán todo lo posible para cumplir con la fecha de entrega preferida. No obstante, la fecha de entrega real se te comunicará posteriormente."
      },
      "header": {
        "bill-of-lading": "BOL:",
        "close": "cerrar",
        "container-numbers-long": "Número de contenedores ({count})",
        "container-numbers-short": "N.º",
        "more": "más",
        "order-city": "Destino:",
        "order-date": "Fecha del pedido: ",
        "order-no": "LW #: ",
        "order-ref": "Ref. del pedido: ",
        "order-reference": "Referencia del pedido:",
        "products-to-order": "Productos a pedir"
      },
      "status": {
        "delivery-date": "Entrega:",
        "label": "Estado:",
        "more-info": "más inf. sobre el estado del pedido"
      }
    },
    "group": {
      "last-order": "Pedido más reciente",
      "see-products": "Haz clic para ver los productos"
    },
    "header": {
      "intro": "Más abajo puedes hacer un nuevo pedido, ver tu historial de pedidos o rápidamente repetir un pedido. ",
      "new-order-button": "Hacer un pedido nuevo",
      "title": "Mis pedidos"
    },
    "new": {
      "confirm-dialog": {
        "button": "Cerrar mensaje",
        "message": "Nuestro servicio de atención al cliente confirmará la composición definitiva del pedido. Es posible que necesitemos un momento para mostrar tu pedido en el resumen.",
        "title": "Gracias por tu pedido en Lamb Weston"
      },
      "footer": {
        "back": "Volver atrás",
        "cancel": "Cancelar",
        "confirm": "Confirmar pedido",
        "next": "Siguiente",
        "recalculate": "Recalcular"
      },
      "preferred-warehouse": "**Ha seleccionado el almacén: {code},** debido a esta selección, para este pedido solo puede **pedir productos de este almacén.** Si desea pedir productos de **otro almacén,** por favor **haga un pedido por separado.**",
      "help-text": "La denominación del producto incluye información acerca de los tamaños de corte y el peso de las cajas.",
      "intro": "Haz tus pedidos de manera rápida y sencilla. Una vez que el pedido se haya introducido en el sistema y se haya procesado, nuestro departamento de Customer Experience te contactará para pasarte las instrucciones para realizar el pago y los datos de entrega.",
      "products-title": "Gama de productos Lamb Weston",
      "products-unavailable": {
        "button": "Ir a seleccionar producto",
        "item-label": "No disponible",
        "message": "El pedido actual contiene un producto que ya no está disponible. Selecciona otro producto en la pantalla de selección de productos. Hemos añadido los otros productos del pedido anterior a la lista de tu pedido.",
        "title": "Pedir estos productos de nuevo - {count} producto(s) no disponible(s)"
      },
      "repeat-button": {
        "large1": "¿Quieres repetir un pedido anterior?",
        "large2": "Volver al resumen del pedido",
        "small": "¿Repetir un pedido?"
      },
      "steps": {
        "order-reference-and-shipping": "Referencia del pedido y envío",
        "order-summary-and-confirmation": "Resumen y confirmación del pedido",
        "select-products": "Seleccionar productos"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "Para aceptar, haz clic en el botón naranja. Tienes la libertad de hacer ajustes alternativos cambiando la cantidad de cualquier artículo de la lista o puedes ignorar nuestra sugerencia y pasar al siguiente paso del proceso de pedido.",
          "title": "¡Podemos optimizar tu pedido! Tenemos una sugerencia para que tu pedido se ajuste a la siguiente escala de volumen de pedidos."
        },
        "tooltip": {
          "message": "Añade **+{quantity}** palé(s) para beneficiarte de una escala de tarifas de flete más baja.",
          "title": "¡Podemos optimizar tu pedido!"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "Para aceptar, haz clic en el botón naranja. Tienes la libertad de hacer ajustes alternativos cambiando la cantidad de cualquier artículo de la lista o puedes ignorar nuestra sugerencia y pasar al siguiente paso del proceso de pedido.",
          "title": "¡Podemos optimizar tu pedido! Tenemos una sugerencia para que tu pedido llene el camión."
        },
        "tooltip": {
          "message": "Añade **+{quantity}** palé(s) para llenar el camión.",
          "title": "¡Podemos optimizar tu pedido!"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "Tenemos una sugerencia para ti basada en tu mayor línea de pedido. Para aceptar, haz clic en el botón naranja. Tienes la libertad de hacer ajustes alternativos cambiando la cantidad de cualquier artículo de la lista. Para continuar, haz clic en recalcular cuando hayas ajustado tu pedido.",
          "title": "Has superado el peso máximo del camión en {quantity} palé(s) ({exceededWeight} kg, incluidos los palés)."
        },
        "tooltip": {
          "message": "Reducir la cantidad de este artículo con **-{quantity}**. Cancelar para reducir la cantidad de otros artículos.",
          "title": "Has superado el peso máximo del camión."
        }
      },
      "suggestion": {
        "accept": "Aceptar",
        "cancel": "Cancelar"
      },
      "title": "Nuevo pedido"
    },
    "custom-label-switch": {
      "title": "Mostrar etiquetas originales",
      "description": "Esto mostrará la información original del producto proporcionada por LambWeston cuando esté activado.",
      "checkbox": "Mostrar nombre y número original del producto"
    },
    "order-item-list": {
      "header": {
        "art": "Material",
        "boxes": "Cajas",
        "code": "Código LW",
        "warehouse": "Almacén",
        "layers": "Capas",
        "pallets": "Palés",
        "product": "Producto",
        "products": "Productos",
        "quantity": "Cantidad",
        "unit-type": "Tipo de unidad"
      },
      "totals": {
        "grand-total": "Total",
        "kg": "kg",
        "total-cartons": "Cartones | Cartón | Cartones",
        "total-gross-weight": "Peso bruto",
        "total-layers": "Capas | Capa | Capas",
        "total-net-weight": "Peso neto",
        "total-pallets": "Palés | Palé | Palés"
      },
      "unit": {
        "bag": "Bolsa",
        "car": "Cartones",
        "kg": "kg",
        "lay": "Capas",
        "pal": "Palés"
      }
    },
    "overview": {
      "closed-orders-title": "Pedidos cerrados",
      "empty": "No hay pedidos disponibles",
      "header": {
        "eta-actual": "ETA actual",
        "eta-booked": "ETA reservado",
        "eta-requested": "Req. ETA",
        "more": "más",
        "order-city": "Destino",
        "order-date": "Fecha del pedido",
        "order-no": "LW #",
        "order-ref": "Ref. del pedido",
        "order-reference": "Referencia del pedido",
        "order-status": "Estado del pedido"
      },
      "open-orders-title": "Pedidos pendientes",
      "search-bar": {
        "query": {
          "placeholder": "Buscar un pedido específico..."
        },
        "status": {
          "all": "Todos los pedidos",
          "placeholder": "Estado del pedido"
        }
      }
    },
    "reference": {
      "intro": "Si deseas añadir un número de referencia/pedido para tu compra rellena el campo de referencia del pedido.",
      "number": {
        "max-characters": "(máximo 20 caracteres)",
        "placeholder": "Introduce tu número de referencia para el pedido",
        "title": "Referencia del pedido"
      },
      "title": "Tu referencia de pedido"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Establecer almacén preferido",
        "filter-products": "Filtrar productos",
        "search": "Buscar un producto específico...",
        "search-alt": "buscar"
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "esta fecha es una estimación",
        "title": "Fecha de entrega preferida"
      },
      "eta": {
        "delayed": "con retraso",
        "early": "antes de tiempo",
        "eta": "ETA:"
      },
      "ship-to": {
        "title": "Enviar a"
      },
      "title": "Envío"
    },
    "status": {
      "AWS_CREATED": "Recibido por Lamb Weston",
      "DELIVERED": "Entregado",
      "SAP_CANCELLED": "Cancelado",
      "SAP_CREATED": "Aceptado",
      "SAP_PROCESSING": "Procesando",
      "SAP_PROCESSING_PART": "Procesando",
      "SAP_SHIPPED": "Enviado",
      "SAP_SHIPPED_PART": "Enviado",
      "SAP_UNKNOWN": "Desconocido",
      "more-info": {
        "AWS_CREATED": "Pedido completado y confirmado a través del portal del cliente. Correo de confirmación enviado.",
        "DELIVERED": "Confirmación de que la mercancía ha sido entregada en el lugar de destino.",
        "SAP_CANCELLED": "Se ha cancelado el pedido.",
        "SAP_CREATED": "El pedido se ha completado y está lista para su salida sin bloqueos ni rechazos.",
        "SAP_PROCESSING": "El pedido está siendo procesado y comprobado por LW Customer Experience.",
        "SAP_PROCESSING_PART": "Procesamiento en SAP, pedido parcialmente aceptado.",
        "SAP_SHIPPED": "El pedido ha sido cargado en su totalidad, PGI (movimiento salida de mercancías) recibido.",
        "SAP_SHIPPED_PART": "Entrega creada en SAP, pedido parcialmente aceptado.",
        "SAP_UNKNOWN": "Para más inf. consulta con tu representante del Departamento de Customer Experience."
      },
      "part": "partly",
      "partly": "incompleto"
    },
    "summary": {
      "delivery-date": "Destino y fecha de entrega preferida",
      "title": "Resumen del pedido"
    },
    "warning": {
      "requires-mfa": "La gestión de pedidos solo está disponible para los usuarios que tienen activada la autenticación multifactor. Puedes configurar la autenticación multifactor en:"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Eliminar",
        "get": "Leer",
        "label": "Acciones",
        "post": "Crear",
        "put": "Actualizar",
        "tooltip": "Más información sobre acciones"
      },
      "configure": {
        "label": "Configurar",
        "tooltip": "Más información sobre la configuración"
      },
      "delete": {
        "label": "Eliminar",
        "tooltip": "Más información sobre la acción eliminar"
      },
      "effect": {
        "label": "Efecto",
        "tooltip": "Más información sobre efecto"
      },
      "endpoint": {
        "label": "Punto final",
        "tooltip": "Más información sobre punto final"
      },
      "field": {
        "label": "Campo"
      },
      "model": {
        "label": "Modelo"
      },
      "operator": {
        "label": "Operario"
      },
      "value": {
        "label": "Valor"
      },
      "wildcard": {
        "label": "Para punto final certificado comodín",
        "tooltip": "Mas información sobre certificado comodín (wildcard)"
      }
    },
    "effect": {
      "allow": "Permitir",
      "deny": "Denegar"
    },
    "intro": "Gestionar roles de usuario y sus permisos. Selecciona primero una función o añade una nueva.",
    "policies": {
      "add": "Añadir nueva política",
      "configure": {
        "actions": "Acciones",
        "effect": "Efecto",
        "endpoint": "Punto final",
        "for-wildcard-endpoint": "Para punto final certificado comodín",
        "id": "ID",
        "locale": "Local",
        "title": "Configurar política",
        "wildcard": "Certificado comodín (wildcard)"
      },
      "delete": {
        "cancel": "Cancelar",
        "confirm": "Eliminar política",
        "message": "¿Seguro que quieres eliminar esta política? Esta acción no es reversible.",
        "success": "Política eliminada correctamente",
        "title": "Eliminando la política"
      },
      "intro": "Políticas para este rol. Puedes configurar las políticas para este rol haciendo clic en el botón de configuración y "
    },
    "policy-form": {
      "cancel": "Cancelar",
      "endpoint": {
        "label": "Punto final",
        "placeholder": "Selecciona un punto final"
      },
      "filters": {
        "add": "Añade un nuevo filtro",
        "title": "Filtros de política"
      },
      "placeholder": {
        "select": {
          "field": "Selecciona un campo",
          "model": "Selecciona un modelo",
          "operator": "Selecciona un operario"
        }
      },
      "submit": "Guardar y salir",
      "title": "Configurar política"
    },
    "role": {
      "add": "Añadir nuevo rol",
      "edit": "Editar nombre de rol",
      "form": {
        "cancel": "Cancelar",
        "error": "Se ha producido un error al guardar el rol",
        "name": {
          "label": "Nombre",
          "placeholder": "Introduce el nombre del rol"
        },
        "submit": "Guardar",
        "success": "Rol guardado",
        "title": "Rol"
      },
      "placeholder": "Selecciona un rol"
    },
    "select-role": "Selecciona primero un rol o haz clic en añadir nuevo rol.",
    "title": "Gestión de permisos"
  },
  "product-information": {
    "contact": {
      "description": "¿Quieres preguntar por un producto nuevo? ¿O tal vez solicitar información sobre un producto que no está en la lista?",
      "link": "Contactar con el Departamento de Customer Experience",
      "subject": "Información del producto en el Portal del Cliente"
    },
    "detail": {
      "intro": "Aquí puede encontrar toda la información disponible sobre este producto.",
      "packaging": {
        "cartons": "envases de cartón",
        "cm": "cm",
        "commodity-code": "Código aduanero del SA",
        "dimensions": "Medidas",
        "ean-upc": "Código EAN",
        "gross-weight": "Peso bruto",
        "height": "altura",
        "kg": "kg",
        "layers": "capas",
        "length": "longitud",
        "material": "Material",
        "net-weight": "Peso neto",
        "pallet-type": "Tipo de palé",
        "shelf-life-code": "Código de vida útil",
        "title": "Embalaje y medidas",
        "unit": {
          "bag": "Embalaje/Bolsa",
          "car": "Envase de cartón",
          "lay": "Capa",
          "pal": "Palé"
        },
        "width": "anchura"
      },
      "product-sheet": {
        "download-button": "Descargar hoja de producto en pdf",
        "information-list": "Información nutricional | Información sobre alergenos | Información sobre la preparación | Información de ejemplo",
        "intro": "Dentro de esta hoja comercial de descripción del producto puede encontrar la siguiente información.",
        "subtitle": "Hoja comercial de descripción del producto en PDF",
        "title": "Hoja de producto"
      }
    },
    "header": {
      "intro": "Aquí encontrarás la información disponible sobre el producto. Haz clic en más información para ver los detalles del producto.",
      "title": "Información del producto"
    },
    "list": {
      "empty": "No hay productos disponibles",
      "header": {
        "details": "más info",
        "download": "descargar pdf"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Editar ajustes de la cuenta",
      "title": "Configuración de la cuenta"
    },
    "edit": "editar",
    "email": {
      "confirmation-code": "Introduce tu código de confirmación"
    },
    "error": {
      "failed": "Se ha producido un error al guardar tu perfil",
      "success": "Tu perfil se ha guardado",
      "wrongPassword": "Has introducido una contraseña incorrecta"
    },
    "label": {
      "cancel": "Cancelar",
      "change-password": "****************",
      "city": "Localidad",
      "country": "País",
      "edit": "Editar perfil",
      "email": "Dirección de correo electrónico",
      "firstName": "Nombre",
      "functionTitle": "Cargo",
      "lastName": "Apellido(s)",
      "locale": "Idioma",
      "newPassword": "Nueva contraseña",
      "newPasswordRepeat": "Vuelve a introducir la contraseña",
      "oldPassword": "Contraseña anterior",
      "phone": "Número de teléfono",
      "restaurantCity": "Localidad",
      "restaurantCountry": "País",
      "restaurantName": "Nombre del restaurante",
      "restaurantNumber": "Número",
      "restaurantPostalcode": "Código postal",
      "restaurantSeats": "Capacidad/número de plazas",
      "restaurantStreet": "Calle",
      "restaurantTelephone": "Teléfono",
      "restaurantType": "Tipo de restaurante",
      "restaurantWebsite": "Sitio web",
      "save": "Guardar"
    },
    "locale": {
      "change-success": "Has cambiado el idioma correctamente"
    },
    "mfa": {
      "current-mfa": "Instalado: ",
      "method": {
        "NOMFA": "sin autenticación multifactor",
        "SMS": "Mensajes de texto SMS (recibe un código en tu móvil)",
        "TOTP": "contraseña de un solo uso (con la aplicación de autenticación)"
      },
      "mfa-description": "La autenticación multifactor (AMF) añade una capa de seguridad adicional para proteger tu nombre de usuario y contraseña. Para activar la autenticación por SMS, facilita un número de móvil válido en la sección superior",
      "no-mfa-description": "No activar AMF",
      "setup-mfa": "Preferencia de autenticación multifactor",
      "sms-description": "Mensajes de texto SMS (recibe un código en tu móvil). Tu número de teléfono debe configurarse correctamente.",
      "token-instructions": "Escanea el código QR con la cámara de tu móvil o la aplicación de autenticación para obtener el código de autenticación multifactor.",
      "totp-description": "Contraseña de un solo uso (utiliza un código QR y una aplicación de autenticación multifactor para guardar un código de autenticación en tu móvil)",
      "totp-info": {
        "1-select-option": "Selecciona la opción \"Contraseña de un solo uso\" y haz clic en \"Establecer AMF”.",
        "2-get-app": "Consigue el {0} para tu móvil",
        "2-get-app-link": "Aplicación de autenticación de Google",
        "3-press-plus": "Pulsa el símbolo \"+\".",
        "4-select-scan": "Selecciona \"Escanear código QR\".",
        "5-enter-code": "Introduce el código de la aplicación como \"Código de verificación\"",
        "title": "Cómo configurar la autenticación con contraseña de un solo uso"
      }
    },
    "no-profile-placeholder": "Para una experiencia óptima en el portal del cliente, completa la información de tu perfil. Haz clic en el icono de la esquina derecha para editar.",
    "password": {
      "change-success": "Has cambiado la contraseña correctamente",
      "do-not-match": "Las contraseñas no coinciden",
      "invalid": "La contraseña debe cumplir con los siguientes requisitos: Longitud mínima de 6 caracteres; incluir caracteres del abecedario inglés en mayúsculas (A-Z); incluir caracteres del alfabeto inglés en minúsculas (a-z); incluir dígitos de base 10 (0-9)."
    },
    "phone": {
      "invalid-phone-number": "Parece que el número de teléfono facilitado no es válido",
      "unknown-error": "Se ha producido un error al guardar tu número de teléfono"
    },
    "placeholder": {
      "city": "P. ej. Londres, Roma",
      "close": "Cerrando",
      "confirmation-code": "123456",
      "country": "Selecciona tu país",
      "email": "mail@chefs.network",
      "functionTitle": "P. ej. chef, subchef",
      "number": "P. ej. 2.ª planta, N.º 4 B",
      "open": "Horarios",
      "password": "Contraseña",
      "phone": "555-3891203812",
      "restaurant": {
        "seats": "P. ej. 100",
        "type": "P. ej. asador, pizzería, etc."
      },
      "staff": "P. ej. 2",
      "street": "P. ej. Gran Vía",
      "zip": "P. ej. 28001"
    },
    "restaurant": {
      "add": "Añadir otro restaurante",
      "address": "Dirección",
      "basic": "Básico",
      "delete": {
        "confirm": "Eliminar restaurante",
        "message": "¿Seguro que quieres eliminar este restaurante?",
        "success": "Tu restaurante ha sido eliminado",
        "title": "Estás a punto de eliminar un restaurante"
      },
      "delete-success": "Tu restaurante ha sido eliminado",
      "edit": "Editar información del restaurante",
      "save-success": "Tu restaurante ha sido guardado",
      "seats": "capacidad/número de plazas",
      "title": "Información sobre el restaurante",
      "type": {
        "(mountain) huts": "Refugios (de montaña)",
        "american diner": "Restaurante americano",
        "american_diner": "Restaurante americano",
        "bar": "Bar",
        "beach resorts": "Complejo costero",
        "beach_resorts": "Complejo costero",
        "bistro": "Bistró",
        "camp sites": "Camping",
        "camp_sites": "Camping",
        "chicken restaurant": "Restaurante de pollo",
        "chicken_restaurant": "Restaurante de pollo",
        "fast food": "Comida rápida",
        "fast_food": "Comida rápida",
        "fish Burger": "Freiduría",
        "fish_burger": "Freiduría",
        "gourmet restaurant": "Restaurante gourmet",
        "gourmet_restaurant": "Restaurante gourmet",
        "grill restaurant": "Asador",
        "grill_restaurant": "Asador",
        "hamburger Restaurant": "Hamburguesería",
        "hamburger_restaurant": "Hamburguesería",
        "mountain_huts": "Refugios (de montaña)",
        "other": "Otros",
        "pizza restaurant": "Pizzería",
        "pizza_restaurant": "Pizzería",
        "pub": "Pub",
        "seafood restaurant": "Marisquería",
        "seafood_restaurant": "Marisquería",
        "snack bar": "Cafetería",
        "snack_bar": "Cafetería",
        "steakhouse": "Asador"
      }
    },
    "title": "Perfil"
  },
  "registration": {
    "label": {
      "password": "Contraseña",
      "restaurantName": "Por favor, indica el nombre del restaurante para el que quieres hacer el cálculo a través de la ingeniería de menús."
    },
    "placeholder": {
      "restaurantName": "Nombre del restaurante"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Cerrar"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Actualización! Nuevas características.",
        "read-more": "Leer más",
        "title": "Actualización! Nuevas características.",
        "content": [
          {
            "title": "Estimado cliente,",
            "content": "Le informamos de que hemos introducido algunos cambios en nuestro Portal del Cliente. Ahora existe la posibilidad de mostrar la descripción de su producto y su número de producto en el portal de cliente. En caso de que falte alguno de sus productos o descripciones, no dude en enviar esta información a su contacto dentro de Lamb Weston.",
            "image": "/img/updates/new-product-cold-store/es/1.jpg"
          },
          {
            "content": "Si sólo desea ver los códigos y descripciones de Lamb Weston, puede marcar esta casilla.",
            "image": "/img/updates/new-product-cold-store/es/2.jpg"
          },
          {
            "content": "A partir de ahora, mostraremos el lugar donde se encuentra el almacén de entrega.",
            "image": "/img/updates/new-product-cold-store/es/3.jpg"
          },
          {
            "content": "Si tiene alguna pregunta sobre estos cambios, póngase en contacto con su interlocutor en Lamb Weston."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "Correo electrónico",
        "placeholder": "El correo electrónico del usuario..."
      },
      "error-message": "Se ha producido un error al añadir el usuario.",
      "intro": "Facilita los siguientes datos y haz clic en el botón de añadir usuario para añadir un nuevo usuario.",
      "locale": {
        "label": "Idioma",
        "placeholder": "Selecciona el idioma preferido"
      },
      "mfa": {
        "phone": "Número de teléfono",
        "title": "Preferencia de autenticación multifactor",
        "use-sms-mfa": "Mensajes de texto SMS (recibe un código en tu móvil)"
      },
      "sap-id": {
        "customer": "Cliente:",
        "label": "SAP ID",
        "no-portal-access": "Este cliente no tiene acceso al Portal de Clientes.",
        "placeholder": "El SAP ID tiene un máximo de 12 caracteres...",
        "unknown-sap-id": "SAP ID desconocido"
      },
      "success-message": "Usuario añadido correctamente.",
      "user-group": {
        "label": "User group",
        "placeholder": "Selecciona el grupo de usuarios"
      }
    },
    "add-new-user": "Añadir nuevo usuario",
    "change-roles": {
      "form": {
        "cancel": "Cancelar",
        "error": "No se han podido guardar los cargos del usuario.",
        "label": "Cambiar cargo(s)",
        "placeholder": "Añadir un cargo",
        "remove": "Eliminar este cargo",
        "submit": "Guardar",
        "success": "Cargos de usuario correctamente guardado"
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Cancelar",
        "error": "No se ha podido cambiar el grupo de usuario",
        "group": {
          "administrators": "Administrador",
          "any": "Cualquier",
          "direct-customers": "Cliente directo",
          "end-users": "Usuarios finales",
          "indirect-customers": "Cliente indirecto",
          "multinationals": "Multinacional",
          "none": "No procede",
          "dock-scheduling-users": "Usuario de programación de muelle",
          "dock-scheduling-employees": "Empleado de programación de muelles"
        },
        "label": "Cambiar grupo de usuario",
        "submit": "Guardar",
        "success": "Grupo de usuario correctamente cambiado."
      }
    },
    "column": {
      "customer": "Cliente",
      "details": "Editar",
      "email": "Correo electrónico",
      "first-name": "Nombre",
      "last-name": "Apellido(s)",
      "status": "Estado",
      "user-group": "User group",
      "vendor": "Socio"
    },
    "details": {
      "change-roles": "Cambiar cargos",
      "change-user-group": "Cambiar grupo de usuario",
      "impersonate": "Hacerse pasar por este usuario",
      "language": "Idioma:",
      "manage-user-intro": "Puedes restablecer la contraseña de este usuario o la autenticación de dos factores haciendo clic en los siguientes botones.",
      "manage-user-title": "Gestionar este usuario",
      "reset-mfa": "Restablecer 2FA",
      "reset-password": "Restablecer contraseña",
      "sap-id": "SAP ID:",
      "sap-id-error": "No se ha podido cambiar el SAP ID",
      "sap-id-placeholder": "Añadir SAP ID",
      "sap-id-success": "SAP ID cambiado correctamente",
      "status": {
        "active": "Activo",
        "inactive": "Inactivo"
      },
      "toggle-active-intro": "Con el interruptor de abajo puedes activar o desactivar el usuario.",
      "toggle-active-title": "Activar y desactivar usuario"
    },
    "group": {
      "administrators": "Administradores",
      "direct-customers": "Clientes directos",
      "end-users": "Usuarios finales",
      "indirect-customers": "Clientes indirectos",
      "dock-scheduling-users": "Usuario de programación de muelle",
      "dock-scheduling-employees": "Empleado de programación de muelles"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Cualquier",
      "direct-customers": "Cliente directo",
      "end-users": "Usuarios finales",
      "indirect-customers": "Cliente indirecto",
      "multinational": "Multinacional",
      "none": "No procede",
      "dock-scheduling-users": "Usuario de programación de muelle",
      "dock-scheduling-employees": "Empleado de programación de muelles"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "Actualmente te haces pasar por",
        "stop": "dejar de hacerse pasar por"
      },
      "dialog": {
        "cancel": "Cancelar",
        "confirm": "Impersonar",
        "message": "¿Estás seguro de que quieres hacerte pasar por \"{email}\"?",
        "title": "Impersonar usuario"
      }
    },
    "intro": "Gestionar tus usuarios. Haz clic en una fila de usuarios para ver más información o posibles acciones del usuario.",
    "reset-mfa": {
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "error": "Se ha producido un error al restablecer la autenticación de dos factores.",
      "message": "¿Seguro que deseas restablecer la autenticación de dos factores para este usuario?",
      "success": "Autenticación de dos factores restablecida.",
      "title": "Restablecer autenticación de dos factores"
    },
    "reset-password": {
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "error": "Se ha producido un error al restablecer la contraseña.",
      "message": "¿Seguro que deseas restablecer la contraseña para este usuario?",
      "success": "Contraseña restablecida.",
      "title": "Restablecer contraseña"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Buscar ...",
        "search-alt": "buscar",
        "users": "Usuarios"
      }
    },
    "status": {
      "active": "activo",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "inactive": "inactivo",
      "message": "¿Seguro que quieres cambiar el estado del usuario?",
      "title": "Activar y desactivar usuario"
    },
    "title": "Gestión de usuarios",
    "update-vendor-button": "Actualizar socio",
    "vendor-label": "Socio",
    "vendor-tooltip": "Actualmente no existe una integración directa con el sistema SAP del proveedor. \nEstablecer un valor permite a un administrador crear reservas para este socio en función de este valor.",
    "product-groups-label": "Grupos de productos",
    "update-product-groups-button": "Actualizar grupos de productos"
  },
  "validation": {
    "ext": "Solo se aceptan archivos con la extensión '{ext}'.",
    "required": "Este campo es obligatorio",
    "totalSize": "No puedes subir más de {totalSize}Mb",
    "quarterly": "Los meses seleccionados no forman un trimestre válido",
    "no-special-characters": "La entrada no puede contener hashtags, comillas, asteriscos ni comas.",
    "password": "La contraseña necesita un mínimo de {length} caracteres",
    "password-repeat": "Las contraseñas no coinciden",
    "email": "Por favor, introduce una dirección de correo electrónico válida",
    "max": "Este campo debe tener como máximo {max} caracteres.",
    "afterTime": "La hora de finalización debe ser posterior a la hora de inicio.",
    "min": "Este campo debe tener al menos {min} caracteres."
  },
  "dock-management": {
    "dock-scheduler-title": "Programador de muelle",
    "select-location": "Ubicación",
    "select-day": "Día",
    "dock-scheduler-no-data": "Selecciona una ubicación y un día para ver y reservar una franja horaria",
    "dock-schedule-table-cell-your-booking": "Tu reserva",
    "dock-schedule-table-cell-booked-by-other": "Reservado",
    "dock-schedule-table-cell-closed": "Cerrado",
    "error-fetching-locations": "Error al recuperar ubicaciones",
    "error-fetching-dock-schedule": "No se pudo recuperar el cronograma",
    "docking-dialog": {
      "booking-id": "@:brand.name referencia de reserva",
      "license-plate": "Matrícula",
      "nationality": "Nacionalidad",
      "remarks": "Observaciones",
      "create-button": "Libro",
      "title": "Atraque para {dock} en {location}",
      "nationality-placeholder": "Elige una nacionalidad",
      "remarks-placeholder": "Por ejemplo, cargar instrucciones u comentarios.",
      "supplier-placeholder": "Por ejemplo Lamb Weston",
      "license-plate-placeholder": "Por ejemplo 22-BDS-02",
      "confirm-dialog": {
        "message": "¿Estás seguro de que quieres eliminar esta reserva? \nEsto será eliminado para todos."
      },
      "transporter": "transportador",
      "booking-id-tooltip": "Número de orden de entrada/salida o de compra.",
      "error-remove-booking-validation": "No se permiten cancelaciones dentro del horario previsto. \nComuníquese con su persona de contacto dentro de @:brand.name",
      "partner-placeholder": "Elige un socio",
      "partner": "A nombre de"
    },
    "error-fetching-bookings": "Error al recuperar reservas",
    "success-creating-booking": "Franja horaria reservada correctamente",
    "error-creating-booking": "Error al reservar una franja horaria",
    "success-deleting-booking": "Reserva eliminada correctamente",
    "error-deleting-booking": "No se pudo eliminar una reserva",
    "success-updating-booking": "Reserva actualizada correctamente",
    "error-updating-booking": "No se pudo actualizar una reserva",
    "dock-schedule-table-cell-no-longer-available": "Este intervalo de tiempo ya no está disponible porque está fuera del período de reserva permitido.",
    "dock-schedule-table-cell-loading-reference-not-found": "No se pudo encontrar el número de referencia.",
    "dock-scheduler-closed-day": "El local permanece cerrado durante todo el día.",
    "dock-schedule-table-lock-dock-tooltip": "No se puede cerrar este muelle, porque ya hay reservas realizadas para este día.",
    "error-unlocking-dock": "No se pudo desbloquear el muelle",
    "error-locking-timeslot": "No se pudo bloquear el muelle",
    "select-booking-period": "Periodo de reserva",
    "error-fetching-notifications": "Error al recuperar notificaciones",
    "location-notifications": {
      "confirm-dialog": {
        "message": "¿Estás seguro de que deseas eliminar esta notificación?"
      },
      "add-notification": "Crear notificación"
    },
    "notification-dialog": {
      "title": "Notificación",
      "message": "Mensaje",
      "is-active": "Está activo"
    },
    "success-deleting-notification": "Notificación eliminada con éxito",
    "error-deleting-notification": "No se pudo eliminar la notificación",
    "success-creating-notification": "Se creó una notificación con éxito",
    "error-creating-notification": "No se pudo crear una notificación",
    "success-updating-notification": "Notificación actualizada con éxito",
    "location-settings-dialog": {
      "title": "Configuración de ubicación",
      "cutoff-time": "Hora límite"
    },
    "success-updating-cutoff-time": "Hora límite actualizada correctamente",
    "error-updating-cutoff-time": "Error al actualizar la hora límite",
    "cutoff-time-label": "Las reservas para el día siguiente cierran a las {time}",
    "error-updating-notification": "Error al actualizar la notificación",
    "error-fetching-partners": "Error al recuperar socios",
    "booking-overview-title": "Resumen de reservas",
    "select-docks": "Muelles",
    "export-bookings-button": "Descargar",
    "export-bookings-subtitle": "Archivo XLSX",
    "export-bookings-title": "Descarga tus reservas anteriores",
    "export-bookings-error": "Exportación fallida",
    "booking-overview-table": {
      "date": "Fecha",
      "time": "Tiempo",
      "location": "Ubicación",
      "dock": "Muelle",
      "reference-number": "Referencia de reserva",
      "partner-id": "Socio externo"
    },
    "dock-booking-overview-no-data": "Sin datos",
    "dock-scheduling-rules-title": "Reglas de programación de muelles",
    "add-dock-scheduling-rule": "Nueva regla de programación de muelles",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} reglas)",
      "no-data": "Aún no se han creado reglas."
    },
    "schedule-dialog": {
      "step-1-instructions": "Elija una ubicación, muelle y grupo de productos para crear una nueva regla",
      "title": "Reglas de programación de muelles",
      "step-2-location": "Ubicación",
      "step-2-selected-docks": "Muelles",
      "step-2-selected-product-groups": "Grupos de productos",
      "location": "Ubicación",
      "docks": "Muelles",
      "product-groups": "Grupos de productos"
    },
    "error-fetching-product-groups": "Error al recibir grupos de productos",
    "error-updating-rule": "Error al actualizar la regla",
    "success-updating-rule": "Regla actualizada con éxito",
    "error-creating-rule": "No se pudo crear una regla",
    "success-creating-rule": "Regla creada exitosamente",
    "error-deleting-rule": "No se pudo eliminar la regla",
    "success-deleting-rule": "Regla eliminada con éxito",
    "error-fetching-rules": "Error al recibir reglas",
    "error-fetching-rule": "Error al recibir reglas"
  },
  "days": {
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado",
    "sunday": "Domingo"
  },
  "userMgtStore": {
    "userVendorUpdated": "Actualizado exitosamente el socio",
    "userProductGroupUpdated": "Se actualizaron correctamente los grupos de productos."
  },
  "captcha": {
    "error": "Algo salió mal con la verificación de seguridad. Por favor, actualice la página e intente de nuevo.",
    "title": "Verificación de seguridad",
    "subtitle": "Por favor, complete la verificación para continuar"
  }
}
